import { shade, rgba, transparentize, lighten } from 'polished'
import base, { type Theme, type LazyTheme, type Palette } from './base'

const palette: Palette = {
  // Accent Colors
  purple: '#98224F',
  bordeaux: '#983323',
  red: '#B71234',
  errorRed: '#983222',
  orange: '#F66D41',
  yellow: '#EEAF30',
  green: '#70A489',
  theatershowblue: '#102183',
  blue: '#64A0C8',
  darkblue: '#4D7D9C',
  black: '#000000',
  white: '#FFFFFF',
  transparent: 'transparent',
  // 50 Shades of grey/brown
  brown: '#4D3928',
  grey: '#A59D95',
  lightgrey: '#EEEEEE',
  // 50 Shades of taupe
  taupe: '#D3BF96',
  lighttaupe: '#EDE5D5',
  xlighttapue: '#F6F2EA',
  xlightgrey: '#FAFAF7',
  disabledcolor: '#C8BCB8',
  disabledborder: '#A39994'
}

const main: LazyTheme = (variant = 'default') => ({
  ...base(variant),
  colors: {
    ...palette,
    primary: palette.red,
    screen: palette.xlightgrey,
    section: palette.xlightgrey,
    panel: palette.xlightgrey,
    body: palette.brown,
    item: palette.white,
    card: palette.white,
    sectionheader: palette.grey,
    divider: palette.lighttaupe,
    placeholder: palette.grey,
    underlay: rgba(0, 0, 0, 0.05),
    footer: rgba(255, 255, 255, 0.2),
    modal: rgba(0, 0, 0, 0.7),
    error: '#FF0000',
    buttons: {
      plain: {
        text: palette.red
      },
      primary: {
        background: palette.red,
        text: palette.white,
        border: rgba(0, 0, 0, 0.15),
        badge: rgba(0, 0, 0, 0.15),
        filler: rgba(0, 0, 0, 0.3),
        disabled: rgba(0, 0, 0, 0.2),
        ripple: rgba(0, 0, 0, 0.5)
      },
      secondary: {
        background: palette.white,
        text: palette.brown,
        border: palette.lighttaupe,
        badge: transparentize(0.75, palette.lighttaupe),
        filler: transparentize(0.5, palette.lighttaupe),
        disabled: 'pink',
        ripple: rgba(0, 0, 0, 0.5)
      },
      facebook: {
        background: '#4266b2',
        text: palette.white,
        border: shade(0.15, '#4266b2'),
        badge: rgba(0, 0, 0, 0.3),
        filler: rgba(0, 0, 0, 0.3),
        disabled: rgba(0, 0, 0, 0.2),
        ripple: rgba(0, 0, 0, 0.5)
      },
      disabled: {
        background: lighten(0.05, palette.lightgrey),
        text: palette.grey,
        border: lighten(0.02, palette.lightgrey),
        badge: lighten(0.025, palette.lightgrey),
        filler: palette.transparent
      },

      primaryDisabled: {
        background: palette.disabledcolor,
        text: palette.white,
        border: shade(0.15, palette.disabledborder),
        filler: rgba(0, 0, 0, 0.1),
        ripple: rgba(0, 0, 0, 0.5)
      },
      simpleRed: {
        background: palette.red,
        text: palette.white,
        border: palette.red,
        filler: rgba(0, 0, 0, 0.1),
        disabled: rgba(0, 0, 0, 0.2),
        ripple: rgba(0, 0, 0, 0.5)
      },
      simpleWhite: {
        background: palette.white,
        text: palette.red,
        border: palette.white,
        filler: transparentize(0.7, palette.lighttaupe),
        disabled: 'pink',
        ripple: rgba(0, 0, 0, 0.5)
      }
    }
  }
}: Theme)

export default main
